module.exports = __webpack_public_path__ + "img/購買星座_mobile.c67c5ab0.png";